function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.625 18V19C23.625 20.105 22.6181 21 21.375 21H5.625C4.38188 21 3.375 20.105 3.375 19V5C3.375 3.895 4.38188 3 5.625 3H21.375C22.6181 3 23.625 3.895 23.625 5V6H13.5C12.2569 6 11.25 6.895 11.25 8V16C11.25 17.105 12.2569 18 13.5 18H23.625ZM13.5 16H24.75V8H13.5V16ZM18 13.5C17.0662 13.5 16.3125 12.83 16.3125 12C16.3125 11.17 17.0662 10.5 18 10.5C18.9338 10.5 19.6875 11.17 19.6875 12C19.6875 12.83 18.9338 13.5 18 13.5Z",
  fill: "black"
});

function SvgAccountInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountInfo);
export default __webpack_public_path__ + "static/media/account-info.70f69350.svg";
export { ForwardRef as ReactComponent };